import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/templates'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_templates',
          component: Index,
          meta: {
            // [PROSPEK] 2026-09-29 Templates hidden unless whatsapp_cloud is enabled
            featureFlag: FEATURE_FLAGS.WHATSAPP_CLOUD,
            // [/PROSPEK]
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
